window.Theme = window.Theme || {};
Theme.Product = (() => {
  // let productSlider, productThumbSlider; // already declared globally in theme-scripts.liquid
  let currentVideo = null;

  const getMousePos = (e) => {
    var pos = e.currentTarget.getBoundingClientRect();
    return {
      x: e.clientX - pos.left,
      y: e.clientY - pos.top,
    };
  };

  function pauseMedia(container) {
    container.querySelectorAll('.yv-youtube-video').forEach(video =>
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    container.querySelectorAll('.yv-vimeo-video').forEach(video =>
      video.contentWindow.postMessage('{"method":"pause"}', '*')
    );
    container.querySelectorAll('video').forEach(video => video.pause());
  }

  function updateGalleryVideoToggleUi(button, playing) {
    if (!button) return;
    button.setAttribute('data-state', playing ? 'playing' : 'paused');
    const playL = button.getAttribute('data-label-play') || 'Play video';
    const pauseL = button.getAttribute('data-label-pause') || 'Pause video';
    button.setAttribute('aria-label', playing ? pauseL : playL);
    const playEl = button.querySelector('.yv-product-gallery-video-toggle__play');
    const pauseEl = button.querySelector('.yv-product-gallery-video-toggle__pause');
    if (playEl) playEl.toggleAttribute('hidden', playing);
    if (pauseEl) pauseEl.toggleAttribute('hidden', !playing);
  }

  function bindGalleryVideoHtml5(slide) {
    const v = slide.querySelector('video');
    if (!v || v.dataset.galleryToggleBound === '1') return;
    v.dataset.galleryToggleBound = '1';
    const btn = slide.querySelector('.yv-product-gallery-video-toggle');
    v.addEventListener('play', () => updateGalleryVideoToggleUi(btn, true));
    v.addEventListener('pause', () => updateGalleryVideoToggleUi(btn, false));
  }

  function playGalleryVideoInSlide(slide) {
    const dm = slide.querySelector('deferred-media[data-product-gallery-video]');
    if (
      dm &&
      typeof dm.loadContent === 'function' &&
      !dm.querySelector('video, iframe') &&
      dm.querySelector('template')
    ) {
      dm.loadContent();
    }
    const btn = slide.querySelector('.yv-product-gallery-video-toggle');
    const tryPlay = () => {
      bindGalleryVideoHtml5(slide);
      const v = slide.querySelector('video');
      if (v) {
        v.muted = true;
        v.play()
          .then(() => updateGalleryVideoToggleUi(btn, true))
          .catch(() => updateGalleryVideoToggleUi(btn, false));
        return;
      }
      slide.querySelectorAll('iframe.yv-youtube-video').forEach((f) => {
        f.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      });
      slide.querySelectorAll('iframe.yv-vimeo-video').forEach((f) => {
        f.contentWindow?.postMessage('{"method":"play"}', '*');
      });
      if (slide.querySelector('iframe.yv-youtube-video, iframe.yv-vimeo-video')) {
        updateGalleryVideoToggleUi(btn, true);
      }
    };
    requestAnimationFrame(() => setTimeout(tryPlay, 50));
    setTimeout(tryPlay, 320);
  }

  function pauseGalleryVideoInSlide(slide) {
    slide.querySelectorAll('video').forEach((v) => v.pause());
    slide.querySelectorAll('iframe.yv-youtube-video').forEach((f) =>
      f.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    );
    slide.querySelectorAll('iframe.yv-vimeo-video').forEach((f) =>
      f.contentWindow?.postMessage('{"method":"pause"}', '*')
    );
    updateGalleryVideoToggleUi(slide.querySelector('.yv-product-gallery-video-toggle'), false);
  }

  function syncProductGalleryActiveVideo(rootEl) {
    if (!rootEl) return;
    rootEl.querySelectorAll('.yv-product-video-item, .yv-product-external-video-item').forEach((slide) => {
      if (!slide.classList.contains('is-selected')) {
        pauseGalleryVideoInSlide(slide);
      }
    });
    const sel = rootEl.querySelector(
      '.yv-product-slider-item.is-selected.yv-product-video-item, .yv-product-slider-item.is-selected.yv-product-external-video-item'
    );
    if (sel) {
      playGalleryVideoInSlide(sel);
    }
  }

  function initProductGalleryVideoControls(rootEl) {
    if (!rootEl || rootEl.dataset.galleryVideoControlsBound === '1') return;
    rootEl.dataset.galleryVideoControlsBound = '1';
    rootEl.addEventListener('click', (e) => {
      const btn = e.target.closest('.yv-product-gallery-video-toggle');
      if (!btn || !rootEl.contains(btn)) return;
      e.preventDefault();
      e.stopPropagation();
      const slide = btn.closest('.yv-product-slider-item');
      if (!slide) return;
      const v = slide.querySelector('video');
      if (v) {
        if (v.paused) {
          v.muted = true;
          v.play().catch(() => {});
        } else {
          v.pause();
        }
        return;
      }
      const yt = slide.querySelector('iframe.yv-youtube-video');
      const vm = slide.querySelector('iframe.yv-vimeo-video');
      const playing = btn.getAttribute('data-state') === 'playing';
      if (yt) {
        yt.contentWindow?.postMessage(
          playing
            ? '{"event":"command","func":"pauseVideo","args":""}'
            : '{"event":"command","func":"playVideo","args":""}',
          '*'
        );
        updateGalleryVideoToggleUi(btn, !playing);
        return;
      }
      if (vm) {
        vm.contentWindow?.postMessage(playing ? '{"method":"pause"}' : '{"method":"play"}', '*');
        updateGalleryVideoToggleUi(btn, !playing);
      }
    });
  }

  /**
   * Fade + absolutely positioned cells + %-padding aspect boxes: Flickity often sets viewport height:0 on mobile,
   * especially when carousel height is "adapt" (theme sets --productSliderHeight to the keyword "adapt").
   */
  function syncProductMainFadeViewport(slider) {
    try {
      const el = slider?.element;
      if (!el || !el.classList.contains('is-fade')) return;
      const vp = el.querySelector('.flickity-viewport');
      if (!vp) return;

      el.style.width = '100%';
      vp.style.width = '100%';

      let sliderW = el.getBoundingClientRect().width;
      if (sliderW <= 1) {
        const wrap = el.closest('.product-detail-slider.main-slider-wrapper');
        sliderW = wrap?.getBoundingClientRect().width || 0;
      }
      if (sliderW <= 1) {
        const col = el.closest('[class*="col-"]');
        sliderW = col?.getBoundingClientRect().width || 0;
      }
      if (sliderW <= 1) {
        sliderW = typeof window !== 'undefined' ? window.innerWidth : 0;
      }
      if (sliderW <= 1) return;

      const cell =
        el.querySelector('.yv-product-slider-item.is-selected') ||
        el.querySelector('.yv-product-slider-item');
      if (!cell) return;
      const wrapper = cell.querySelector(':scope > .image-wrapper') || cell.querySelector('.image-wrapper');
      if (!wrapper) return;

      let ratio = null;
      const pbInline = wrapper.style.paddingBottom || '';
      const pct = pbInline.match(/^([\d.]+)\s*%/);
      if (pct) {
        ratio = parseFloat(pct[1]) / 100;
      }
      if (ratio == null || !Number.isFinite(ratio) || ratio <= 0) {
        const img = wrapper.querySelector('img');
        if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
          ratio = img.naturalHeight / img.naturalWidth;
        }
      }
      if (ratio == null || !Number.isFinite(ratio) || ratio <= 0) {
        ratio = 1;
      }

      const h = Math.max(1, Math.round(sliderW * ratio));
      vp.style.height = `${h}px`;

      requestAnimationFrame(() => {
        try {
          slider.resize();
        } catch (_) {
          /* noop */
        }
      });

      el.querySelectorAll('.yv-product-slider-item .image-wrapper img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => syncProductMainFadeViewport(slider), { once: true });
        }
      });
    } catch (_) {
      /* noop */
    }
  }

 function initProductSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        delete sliderMain.dataset.galleryVideoControlsBound;
        productSlider?.destroy();
      }
    }

    function bindMainChange() {
      if (!productSlider) return;
      const runSync = () => syncProductMainFadeViewport(productSlider);
      productSlider.on('change', function () {
        pauseMedia(productSlider.element);
        runSync();
        syncProductGalleryActiveVideo(productSlider.element);
      });
      productSlider.on('settle', runSync);
    }

    function finalizeNewMainSlider(sliderMainEl) {
      bindMainChange();
      initProductGalleryVideoControls(sliderMainEl);
      const run = () => syncProductMainFadeViewport(productSlider);
      requestAnimationFrame(run);
      setTimeout(run, 50);
      setTimeout(run, 200);
      setTimeout(() => productSlider?.resize?.(), 300);
      setTimeout(() => syncProductGalleryActiveVideo(sliderMainEl), 450);
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          finalizeNewMainSlider(sliderMain);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productSlider = new Flickity(sliderMain, options);
          finalizeNewMainSlider(sliderMain);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productSlider = new Flickity(sliderMain, options);
        finalizeNewMainSlider(sliderMain);
      } else {
        syncProductMainFadeViewport(productSlider);
        initProductGalleryVideoControls(sliderMain);
        syncProductGalleryActiveVideo(sliderMain);
      }
    }
  }

  function initProductThumbSlider(section = document) {
    let sliderMain = section.querySelector('[data-flickity-product-thumb-slider]');
    if (!sliderMain) return;

    let optionContainer = sliderMain.getAttribute('data-flickity-product-thumb-slider');
    if (!optionContainer) return;

    let options = JSON.parse(optionContainer);

    function destroyIfEnabled() {
      if (sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider?.destroy();
      }
    }

    function bindThumbChange() {
      if (!productThumbSlider) return;
      productThumbSlider.on('change', function () {
        pauseMedia(productThumbSlider.element);
      });
    }

    if (sliderMain.hasAttribute("data-mobile-only")) {
      if ($(window).width() < 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          bindThumbChange();
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else if (sliderMain.hasAttribute("data-desktop-only")) {
      if ($(window).width() >= 768) {
        if (!sliderMain.classList.contains('flickity-enabled')) {
          productThumbSlider = new Flickity(sliderMain, options);
          bindThumbChange();
          setTimeout(() => productThumbSlider.resize(), 300);
        }
      } else {
        destroyIfEnabled();
      }
    } else {
      if (!sliderMain.classList.contains('flickity-enabled')) {
        productThumbSlider = new Flickity(sliderMain, options);
        bindThumbChange();
        setTimeout(() => productThumbSlider.resize(), 300);
      }
    }
  }

  /** Main gallery must exist before thumb (asNavFor). Call this instead of the two inits separately. */
  function initProductGallerySliders(section = document) {
    initProductSlider(section);
    requestAnimationFrame(() => {
      initProductThumbSlider(section);
      const bumpLayout = () => {
        try {
          productSlider?.reloadCells?.();
        } catch (_) {
          /* noop */
        }
        productSlider?.resize?.();
        productThumbSlider?.resize?.();
        syncProductMainFadeViewport(productSlider);
      };
      setTimeout(bumpLayout, 50);
      setTimeout(bumpLayout, 300);
      setTimeout(bumpLayout, 800);
    });
  }

  function findVisibleItems() {
    let mainSliderParent = document.getElementById('yv-product-gallery-slider');
    if (mainSliderParent) {
      let elements = mainSliderParent.getElementsByClassName('gallery-main-item');
      let thumbs = mainSliderParent.getElementsByClassName('gallery-thumbs-item');

      window.addEventListener('scroll', () => {
        Array.from(elements).forEach(item => {
          if (isOnScreen(item)) {
            let relatedThumb = mainSliderParent.querySelector('.gallery-thumbs-item[data-image="' + item.id + '"]');
            if (relatedThumb) {
              Array.from(thumbs).forEach(thumb => thumb.classList.remove('active'));
              relatedThumb.classList.add('active');
            }
          }
        });
      });
    }
    let mainTabsContent =  document.getElementById('yvProductFeatureListwrapper');
    if(mainTabsContent){
      let contentTabs = document.getElementsByClassName('yv-product-feature');	
      window.addEventListener('scroll', function(event){     
        Array.from(contentTabs).forEach(function(item) {
          if (isOnScreen(item)) {
            let headTabs = document.getElementsByClassName('feature-link');
            Array.from(headTabs).forEach(function(head) {
              head.parentNode.classList.remove('active');
            });
            var relatedHead = document.querySelector('.feature-link[href="#'+item.id+'"]');
            if(relatedHead){
              relatedHead.parentNode.classList.add('active');
            }
          }
        });
      });
    }
  }

  function sizeChart() {
    let sizeChartInit = document.querySelectorAll('.sizeChart-label');
    let sizeChartModel = document.getElementById('sizeChartModel');
    if (sizeChartInit && sizeChartModel) {
      let sizeChartClose = sizeChartModel.querySelector('#sizeChartClose');
      sizeChartInit.forEach(label => {
        label.addEventListener("click", e => {
          e.preventDefault();
          // $(sizeChartModel).fadeIn(100);
          document.body.classList.add('sizeChartOpen');
          sizeChartClose.focus();
        });
      });
      sizeChartClose.addEventListener("click", () => {
        document.body.classList.remove('sizeChartOpen');
        // $(sizeChartModel).fadeOut(100);
      });
    }
  }

  function initStickyAddToCart() {
    let mainProductForm = document.querySelector('.main-product-form');
    let stickyBar = document.getElementById('yvProductStickyBar');

    if (mainProductForm && stickyBar) {
      window.addEventListener('scroll', () => {
        if (isOnScreen(mainProductForm, true) || window.scrollY < mainProductForm.offsetTop) {
          stickyBar.classList.remove('show');
        } else {
          stickyBar.classList.add('show');
        }
      });
    }
  }

  function onReadyEvent() {
    setTimeout(function () {
      var thumbnails = document.querySelector('.yv-product-gallery-thumbs-container');
      var lastKnownY = window.scrollY;
      var currentTop = 0;
      if (thumbnails) {
        var initialTopOffset = parseInt(window.getComputedStyle(thumbnails).top);
        window.addEventListener('scroll', function (event) {
          var bounds = thumbnails.getBoundingClientRect(),
            maxTop = bounds.top + window.scrollY - thumbnails.offsetTop + initialTopOffset,
            minTop = thumbnails.clientHeight - window.innerHeight;
          if (window.scrollY < lastKnownY) {
            currentTop -= window.scrollY - lastKnownY;
          } else {
            currentTop += lastKnownY - window.scrollY;
          }
          currentTop = Math.min(Math.max(currentTop, -minTop), maxTop, initialTopOffset);
          lastKnownY = window.scrollY;
          thumbnails.style.top = "".concat(currentTop, "px");
        });
      }
    }, 1000);

    // jQuery('body').on('click', '.gallery-thumbs-item', function (e) {
    //   e.preventDefault();
    //   var destination = jQuery(this).attr('data-image');
    //   var top = jQuery('.shopify-section-main-header').height() + 10;
    //   if (jQuery('#' + destination + '.gallery-main-item').length > 0) {
    //     jQuery('html,body').animate({ scrollTop: (jQuery('#' + destination + '.gallery-main-item').offset().top) - top });
    //   }
    // });

    jQuery('body').on('click', '.pdp-view-close', function (e) {
      e.preventDefault();
      jQuery('#yvProductStickyBar').remove();
    });

    jQuery('body').on('click', '.feature-link', function (e) {
      e.preventDefault();
      let destination = jQuery(this).attr('href');
      let top = jQuery('.shopify-section-main-header').height() + 90;
      if (jQuery(destination).length > 0) {
        jQuery('html,body').animate({ scrollTop: (jQuery(destination).offset().top) - top });
      }
    });

    jQuery('body').on('change', '.sticky-bar-product-options', function () {
      let _section = jQuery(this).closest('.shopify-section');
      let option = jQuery(this).attr('data-name');
      let value = jQuery(this).val();
      let mainOption = _section.find('.productOption[name="' + option + '"]');
      if (mainOption.is(':radio')) {
        _section.find('.productOption[name="' + option + '"][value="' + CSS.escape(value) + '"]').attr('checked', true).trigger('click');
      } else {
        mainOption.val(value);
        let sectionId = document.querySelector('#' + _section.attr('id'));
        if (sectionId) {
          let optionSelector = document.querySelector('.productOption[name="' + option + '"]');
          if (optionSelector) {
            optionSelector.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    if (typeof fancySelector !== 'undefined') {
      Fancybox.bind(fancySelector, {
        touch: false,
        thumbs: {
          autoStart: true
        },
        on: {
          load: () => pauseMedia(document),
          done: () => pauseMedia(document)
        },
        Toolbar: {
          display: ["close"]
        }
      });
    }
  }

  function productZoomInit() {
    $('.yv-product-zoom').mouseenter(function (e) {
      $('.yv-product-zoom').removeClass('show');
      if ($(window).width() > 1021) {
        $(this).addClass('show');
      }
    });
    $('.yv-product-zoom').mousemove(function (e) {
      if ($(window).width() > 1021) {
        let t = getMousePos(e);
        this.querySelector('.gallery-cursor').style.translate = `${t.x}px ${t.y}px`;
      }
    });
    $('.yv-product-zoom').mouseleave(function (e) {
      $('.yv-product-zoom').removeClass('show');
    });
  }

  function load3DModel() {
    if (!window.Shopify) return;

    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: () => {
          if (!window.ShopifyXR || typeof window.ShopifyXR.addModels !== 'function') {
            document.addEventListener('shopify_xr_initialized', () => {
              load3DModel();
            });
            return;
          }

          document.querySelectorAll('[id^="product3DModel-"]').forEach((model) => {
            window.ShopifyXR.addModels(JSON.parse(model.textContent));
          });
          window.ShopifyXR.setupXRElements();
        }

      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: () => {
          document.querySelectorAll('.yv-product-model-item').forEach((model) => {
            let model3D = model.querySelector('model-viewer');
            model.modelViewerUI = new Shopify.ModelViewerUI(model3D);
            model3D.addEventListener('shopify_model_viewer_ui_toggle_play', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.remove('hidden'));
              if (productSlider) {
                productSlider.options.draggable = false;
                productSlider.updateDraggable();
              }
            });
            model3D.addEventListener('shopify_model_viewer_ui_toggle_pause', () => {
              model.querySelectorAll('.close-product-model').forEach(el => el.classList.add('hidden'));
              if (productSlider) {
                productSlider.options.draggable = true;
                productSlider.updateDraggable();
              }
            });
            model.querySelectorAll('.close-product-model').forEach(el => {
              el.addEventListener('click', () => model.modelViewerUI.pause());
            });
          });
        }
      }
    ]);
  }

  function onLoad(section = document) {
    initProductGallerySliders(section);
if (typeof findVisibleItems === 'function') {
  findVisibleItems();
}
    productZoomInit();
    sizeChart();
    initStickyAddToCart();
    load3DModel();
    onReadyEvent();
  }

  $(document).ready(function () {
    onLoad(document);
    onReadyEvent();

    function playVideo() {
      currentVideo = $('[data-reel-content] video')[0];
      if (currentVideo) {
        currentVideo.load();
        currentVideo.play();
      }
    }

    function pauseVideo() {
      if (currentVideo) {
        currentVideo.pause();
      }
    }
  });

  return {
    initProductSlider,
    initProductThumbSlider,
    initProductGallerySliders,
    syncProductMainFadeViewport
  };
})();

if (document.querySelector('[data-flickity-product-slider]')) {
  window.addEventListener('resize', function () {
    Theme.Product.initProductGallerySliders();
    Theme.Product.syncProductMainFadeViewport?.(productSlider);
    if (typeof findVisibleItems === 'function') {
      findVisibleItems();
    }
  });
}


